import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { MapPin, Sparkles } from 'lucide-react';

const AboutSection = ({ portfolioData }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 pt-20 px-6 py-12">
      <div className="max-w-5xl w-full">
        <Card className="bg-slate-900 border-slate-800 p-6 md:p-10">
          <div className="text-center mb-6">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-3 animate-fade-in">
              {portfolioData.personal.name}
            </h1>
            <p className="text-xl md:text-2xl text-blue-400 mb-4">{portfolioData.personal.title}</p>
            <div className="flex items-center justify-center gap-2 text-slate-400 mb-6">
              <MapPin size={18} />
              <span>{portfolioData.personal.location}</span>
            </div>
          </div>
          
          <div className="mb-8">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-4 text-center">About Me</h2>
            <div className="text-base md:text-lg text-slate-300 leading-relaxed space-y-3 max-h-[45vh] overflow-y-auto custom-scrollbar">
              {portfolioData.personal.bio.split('. ').map((sentence, index, array) => {
                // Add period back except for the last sentence if it already has one
                const text = index === array.length - 1 ? sentence : sentence + '.';
                return (
                  <p key={index} className="leading-relaxed">
                    {text}
                  </p>
                );
              })}
            </div>
          </div>
          
          {/* Animated Explore Portfolio Button */}
          <div className="flex justify-center">
            <Link to="/portfolio">
              <Button 
                className="bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 text-white px-8 py-5 text-base md:text-lg rounded-full shadow-lg hover:shadow-blue-500/50 transition-all duration-300 hover:scale-105 animate-pulse-slow group"
              >
                <Sparkles size={20} className="mr-2 group-hover:rotate-12 transition-transform" />
                Explore My Portfolio
                <Sparkles size={20} className="ml-2 group-hover:-rotate-12 transition-transform" />
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AboutSection;
